import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Underline = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24">
    <path d="M14.1172 7.46875H15.7285V13.1348C15.7285 13.7871 15.5879 14.3359 15.3066 14.7812C15.0254 15.2227 14.6426 15.5566 14.1582 15.7832C13.6738 16.0059 13.123 16.1172 12.5059 16.1172C11.8809 16.1172 11.3242 16.0059 10.8359 15.7832C10.3477 15.5566 9.96484 15.2227 9.6875 14.7812C9.41016 14.3359 9.27148 13.7871 9.27148 13.1348V7.46875H10.8828V13.1348C10.8828 13.5332 10.9492 13.8594 11.082 14.1133C11.2148 14.3633 11.4023 14.5488 11.6445 14.6699C11.8867 14.791 12.1738 14.8516 12.5059 14.8516C12.8418 14.8516 13.1289 14.791 13.3672 14.6699C13.6094 14.5488 13.7949 14.3633 13.9238 14.1133C14.0527 13.8594 14.1172 13.5332 14.1172 13.1348V7.46875Z" />
    <path d="M8.55664 17.1719H16.4375V17.7578H8.55664V17.1719Z" />
  </SvgIcon>
));

export default React.memo(Underline);
